import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import ReactSwitch from "react-switch";
import { assignProgram, getAllPrograms } from "../../../actions/emActions";
import ChangeTime from "../../teacherComponents/ClassStart/ChangeTime";
import { imageLink } from "../../../actions/utility";
import emptyImage from "../../../public/images/empty.svg";

const CourseData = [
  {
    id: 1,
    courseName: "Creative Writing Online Classes - Grade 2",
    timeTable: [
      { id: 1, day: "Monday", is_on: true, start: "06:00PM", end: "06:30PM" },
      { id: 2, day: "Tuesday", is_on: true, start: "03:15PM", end: "04:15PM" },
      { id: 3, day: "Wednesday", is_on: true, start: "11:10AM", end: "09:30PM" },
      { id: 4, day: "Thursday", is_on: true, start: "03:30PM", end: "06:00PM" },
      { id: 5, day: "Friday", is_on: true, start: "6:00PM", end: "9:00PM" },
      { id: 6, day: "Saturday", is_on: false, start: "", end: "" },
      { id: 7, day: "Sunday", is_on: false, start: "", end: "" },
    ],
  },
];

const CoursesDetails = ({ studentsProgram, studentId }) => {
  const [programsData, setprogramsData] = useState([]);
  const [isCustomize, setisCustomize] = useState(false);
  const [listView, setlistView] = useState("list");

  useEffect(() => {
    // getAllPrograms().then((res) => {
    //   setprogramsData(res.data);
    // });
  }, []);

  const onSelectProgram = (value) => {
    const data = JSON.parse(value);
    debugger;
    assignProgram(parseInt(studentId), data.program_id, data.id, false).then((res) => {
      console.log("Program Assign Response", res);
    });
  };

  const formatTime = (time) => {
    return time.slice(0, -2) + " " + time.slice(-2);
  };
  return (
    <div className="row">
      {/* <div className="col-md-12">
        <label className="font-weight-bold">Enroll students to a new course</label>
      </div>
      <div className="col-md-12">
        <select className="form-control" onChange={(e) => onSelectProgram(e.target.value)}>
          <option>--Select Course--</option>
          {programsData.map((item) => (
            <option value={JSON.stringify(item)}>{item.course_name}</option>
          ))}
        </select>
      </div> */}
      <div className="col-md-12 mt-3 d-flex justify-content-between">
        <label className="font-weight-bold">Total courses that this student has taken:</label>

        {/* <div>
          <button
            className={listView === "list" ? "viewBtns active" : "viewBtns"}
            onClick={() => setlistView("list")}
          >
            <i className="fa fa-list" />
          </button>
          <button
            className={listView === "grid" ? "viewBtns active" : "viewBtns"}
            onClick={() => setlistView("grid")}
          >
            <i className="fa fa-th" />
          </button>{" "}
        </div> */}
      </div>
      {listView === "list" ? (
        <div className="col-md-12">
          <div className="registeredCourses">
            <div className="row">
              {studentsProgram &&
                studentsProgram.map((item) => (
                  <div className="col-md-4 mt-3">
                    <div className="whiteBg" style={{ background: "#fff" }}>
                      <img
                        className="courseImg"
                        src={`https://lm-neuro-src.s3.amazonaws.com/dashboard/public/uploads/${item?.lm_course?.course_img}`}
                      />
                      <div className="p-3">
                        <label className="">
                          <span
                            className=""
                            style={{ fontSize: 17, color: "rgb(24, 43, 73)", fontWeight: 600 }}
                          >
                            {" "}
                            {item?.lm_course?.course_name}{" "}
                          </span>
                        </label>
                        <br />
                        <img
                          className=""
                          style={{ height: 40, width: 40, borderRadius: "50%" }}
                          src={
                            item?.teacher_nu_users
                              ? imageLink(item?.teacher_nu_users?.image)
                              : emptyImage
                          }
                        />
                        <label className="text-muted ml-3" style={{ fontSize: 12 }}>
                          Taught by:
                        </label>{" "}
                        <span>
                          {item?.teacher_nu_users?.user_name
                            ? item?.teacher_nu_users?.user_name
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : (
        studentsProgram &&
        studentsProgram.map((item) => (
          <div className="col-md-12 mt-2">
            <div className="registeredCourses d-flex justify-content-between">
              <div>
                <label>{item?.lm_course?.course_name}</label>
                <div>
                  <label className="mb-0">Select Teacher:</label>
                  <select className="form-control form-control-sm w-50">
                    <option>Teachers</option>
                  </select>
                </div>
                <div className="mt-2">
                  <label className="mb-0">Customized Program:</label>
                  <br />
                  <ReactSwitch
                    checked={isCustomize}
                    onChange={() => setisCustomize(!isCustomize)}
                    className="my-auto mx-auto"
                    height={20}
                    width={40}
                  />
                </div>
                {isCustomize ? (
                  <div className="mt-2">
                    <label className="mb-0">Time table:</label>
                    <div className="row justify-content-between">
                      {CourseData[0].timeTable &&
                        CourseData[0].timeTable.map((item) => (
                          <div className="col text-center">
                            <div className="mb-2">
                              <ReactSwitch
                                width={40}
                                height={20}
                                checked={item.is_on}
                                className=""
                              />
                              <br />
                              <label className="">{item.day}</label>
                              <div className="text-center">
                                <ReactDatePicker
                                  className="calender-container calender-container-input"
                                  selected={new Date(`01/01/1970 ${formatTime(item.start)}`)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  disabled={!item.is_on}
                                />

                                <ReactDatePicker
                                  className="calender-container calender-container-input"
                                  selected={new Date(`01/01/1970 ${formatTime(item.end)}`)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  disabled={!item.is_on}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <label className="mb-0">Select Slot:</label>
                    <select className="form-control form-control-sm w-50">
                      <option>Slots</option>
                    </select>
                  </div>
                )}
              </div>

              <div className="my-auto">
                <i className="fa fa-trash-o text-danger"></i>
              </div>
            </div>
          </div>
        ))
      )}
      {/* {studentsProgram &&
        studentsProgram.map((item) => (
          <div className="col-md-12 mt-2">
            <div className="registeredCourses d-flex justify-content-between">
              <div>
                <label>{item?.lm_course?.course_name}</label>
                <div>
                  <label className="mb-0">Select Teacher:</label>
                  <select className="form-control form-control-sm w-50">
                    <option>Teachers</option>
                  </select>
                </div>
                <div className="mt-2">
                  <label className="mb-0">Customized Program:</label>
                  <br />
                  <ReactSwitch
                    checked={isCustomize}
                    onChange={() => setisCustomize(!isCustomize)}
                    className="my-auto mx-auto"
                    height={20}
                    width={40}
                  />
                </div>
                {isCustomize ? (
                  <div className="mt-2">
                    <label className="mb-0">Time table:</label>
                    <div className="row justify-content-between">
                      {CourseData[0].timeTable &&
                        CourseData[0].timeTable.map((item) => (
                          <div className="col text-center">
                            <div className="mb-2">
                              <ReactSwitch
                                width={40}
                                height={20}
                                checked={item.is_on}
                                className=""
                              />
                              <br />
                              <label className="">{item.day}</label>
                              <div className="text-center">
                                <ReactDatePicker
                                  className="calender-container calender-container-input"
                                  selected={new Date(`01/01/1970 ${formatTime(item.start)}`)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  disabled={!item.is_on}
                                />

                                <ReactDatePicker
                                  className="calender-container calender-container-input"
                                  selected={new Date(`01/01/1970 ${formatTime(item.end)}`)}
                                  showTimeSelect
                                  showTimeSelectOnly
                                  timeIntervals={5}
                                  timeCaption="Time"
                                  dateFormat="h:mm aa"
                                  disabled={!item.is_on}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <label className="mb-0">Select Slot:</label>
                    <select className="form-control form-control-sm w-50">
                      <option>Slots</option>
                    </select>
                  </div>
                )}
              </div>

              <div className="my-auto">
                <i className="fa fa-trash-o text-danger"></i>
              </div>
            </div>
          </div>
        ))} */}
    </div>
  );
};

export default CoursesDetails;
